import { createAction } from 'typesafe-actions'

const toggleVatInclusion = createAction('CMD / VAT / toggle inclusion')()

export default toggleVatInclusion
